var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFire = function SvgFire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EC008C",
    fillRule: "evenodd",
    d: "m12.118 10.6 3.457-6.93L16.7 4.894c6.305 6.879 8.301 11 8.301 14.488 0 4.834-4.167 8.625-9.144 8.625s-9.144-3.79-9.144-8.625c0-1.42.496-2.953 1.161-4.395.674-1.462 1.568-2.93 2.466-4.25l.783-1.149zm.618 3.883-1.272-1.29a25 25 0 0 0-1.515 2.752c-.61 1.324-.951 2.502-.951 3.438 0 1.287.422 2.5 1.152 3.514a4 4 0 0 1-.009-.287c0-.856.346-1.716.742-2.446.41-.754.945-1.497 1.469-2.151l.74-.925.513.442 1.985-3.38 1.043.966c3.586 3.322 4.938 5.488 4.938 7.494q0 .145-.01.287a6 6 0 0 0 1.153-3.514c0-2.395-1.26-5.668-6.585-11.703zm1.452 6.567-.763-.657q-.302.438-.533.862c-.333.613-.465 1.068-.465 1.355 0 1.143 1.275 2.488 3.429 2.488s3.429-1.345 3.429-2.488c0-.829-.487-2.165-3.175-4.831z",
    clipRule: "evenodd"
  })));
};
export default SvgFire;